const API_BASE_URL = 'https://www.iprod.com.ua/userservice/';
const API_BASE_URL_DEV = 'https://www.iprod.com.ua/userservice/';

export default {
  apiBaseUrl: API_BASE_URL,
  apiBaseUrlDev: API_BASE_URL_DEV
};
